"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import Image from "next/image";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyWhyChooseProps {
  heading?: string;
  description?: string;
  imageSrc?: string;
  imageAlt?: string;
  className?: string;
}
export default function ShopifyWhyChoose(t0) {
  const $ = _c(69);
  const {
    heading: t1,
    description: t2,
    imageSrc: t3,
    imageAlt: t4,
    className: t5
  } = t0;
  const heading = t1 === undefined ? "Why Should You Choose Shopify Technology?" : t1;
  const description = t2 === undefined ? "Shopify offers all the tools and technologies you need to run a successful eCommerce website or online store. From Google Ads to Merchant center all make Shopify a prime choice among entrepreneurs." : t2;
  const imageSrc = t3 === undefined ? "/images/shopify/choose-techno.png" : t3;
  const imageAlt = t4 === undefined ? "Why Choose Shopify Technology" : t4;
  const className = t5 === undefined ? "" : t5;
  const desktopAnimations = useDesktopAnimations();
  useReducedMotion();
  const t6 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t7;
  } else {
    t7 = $[0];
  }
  let t8;
  if ($[1] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[1] = desktopAnimations;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== desktopAnimations) {
    t10 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  let t12;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      once: true
    };
    t12 = {
      duration: 0.7,
      ease
    };
    $[7] = t11;
    $[8] = t12;
  } else {
    t11 = $[7];
    t12 = $[8];
  }
  let t13;
  if ($[9] !== heading) {
    t13 = <h2 className="font-poppins text-[32px] font-bold leading-[1.2] text-[#0b1354] sm:text-[40px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[9] = heading;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== description) {
    t14 = <p className="font-sans mt-5 max-w-xl text-[15.5px] leading-[28px] text-[#5e6282] sm:text-[16.5px] dark:text-gray-300">{description}</p>;
    $[11] = description;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== t10 || $[14] !== t13 || $[15] !== t14 || $[16] !== t8 || $[17] !== t9) {
    t15 = <motion.div initial={t8} whileInView={t9} animate={t10} viewport={t11} transition={t12}>{t13}{t14}</motion.div>;
    $[13] = t10;
    $[14] = t13;
    $[15] = t14;
    $[16] = t8;
    $[17] = t9;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== desktopAnimations) {
    t16 = desktopAnimations ? {
      opacity: 0,
      y: 35
    } : false;
    $[19] = desktopAnimations;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== desktopAnimations) {
    t17 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[21] = desktopAnimations;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== desktopAnimations) {
    t18 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[23] = desktopAnimations;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      once: true
    };
    t20 = {
      duration: 0.8,
      delay: 0.15,
      ease
    };
    $[25] = t19;
    $[26] = t20;
  } else {
    t19 = $[25];
    t20 = $[26];
  }
  let t21;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="flex justify-start pl-12 sm:pl-28"><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#dff3ea] px-5 py-2.5 text-[14px] font-medium text-[#1c734e] shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#142920] dark:text-[#58d49f]">Multiple Payment Gateways</span></div>;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="flex flex-wrap items-center gap-2.5 pl-6 sm:gap-3 sm:pl-16"><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#9d60d3] px-5 py-2.5 text-[14px] font-medium text-white shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#7b3caa]">SEO-Optimized</span><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#e2f1e6] px-5 py-2.5 text-[14px] font-medium text-[#2e7442] shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#182a1d] dark:text-[#64d084]">SEO-friendly</span></div>;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="flex flex-wrap items-center gap-2.5 sm:gap-3"><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#fde5d5] px-5 py-2.5 text-[14px] font-medium text-[#b65324] shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#2d1e16] dark:text-[#f89b6c]">Built-in Marketing Tools</span><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#a662dc] px-5 py-2.5 text-[14px] font-medium text-white shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#8643bd]">POS Integrations</span></div>;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="flex flex-wrap items-center gap-2.5 pl-8 sm:gap-3 sm:pl-14"><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#d4d6fc] px-5 py-2.5 text-[14px] font-medium text-[#3e48ab] shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#1b1e36] dark:text-[#8894fa]">Easy Management</span><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#d5f3ea] px-5 py-2.5 text-[14px] font-medium text-[#1e6f51] shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#142822] dark:text-[#52d2a4]">Tons of Themes</span></div>;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="flex flex-wrap items-center gap-2.5 pl-2 sm:gap-3 sm:pl-6"><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#fddcd0] px-5 py-2.5 text-[14px] font-medium text-[#b84824] shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#2d1b15] dark:text-[#f79471]">Powerful Analytics</span><span className="inline-flex cursor-default items-center justify-center rounded-full bg-[#d8eedd] px-5 py-2.5 text-[14px] font-medium text-[#29673a] shadow-sm transition-transform duration-300 hover:scale-105 sm:px-6 sm:py-3 sm:text-[15px] dark:bg-[#16271c] dark:text-[#63cd82]">Seamless Integrations</span></div>;
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  let t26;
  if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
    t26 = <motion.div initial={t16} whileInView={t17} animate={t18} viewport={t19} transition={t20} className="mt-8 flex flex-col gap-2.5 sm:gap-3">{t21}{t22}{t23}{t24}{t25}</motion.div>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
    $[35] = t26;
  } else {
    t26 = $[35];
  }
  let t27;
  if ($[36] !== t15 || $[37] !== t26) {
    t27 = <div className="lg:col-span-6">{t15}{t26}</div>;
    $[36] = t15;
    $[37] = t26;
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  let t28;
  if ($[39] !== desktopAnimations) {
    t28 = desktopAnimations ? {
      opacity: 0,
      scale: 0.94
    } : false;
    $[39] = desktopAnimations;
    $[40] = t28;
  } else {
    t28 = $[40];
  }
  let t29;
  if ($[41] !== desktopAnimations) {
    t29 = desktopAnimations ? {
      opacity: 1,
      scale: 1
    } : undefined;
    $[41] = desktopAnimations;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  let t30;
  if ($[43] !== desktopAnimations) {
    t30 = desktopAnimations ? undefined : {
      opacity: 1,
      scale: 1
    };
    $[43] = desktopAnimations;
    $[44] = t30;
  } else {
    t30 = $[44];
  }
  let t31;
  let t32;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      once: true
    };
    t32 = {
      duration: 0.8,
      delay: 0.2,
      ease
    };
    $[45] = t31;
    $[46] = t32;
  } else {
    t31 = $[45];
    t32 = $[46];
  }
  let t33;
  if ($[47] !== desktopAnimations) {
    t33 = desktopAnimations ? {
      y: [0, -12, 0]
    } : undefined;
    $[47] = desktopAnimations;
    $[48] = t33;
  } else {
    t33 = $[48];
  }
  let t34;
  if ($[49] !== desktopAnimations) {
    t34 = desktopAnimations ? {
      duration: 4.5,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[49] = desktopAnimations;
    $[50] = t34;
  } else {
    t34 = $[50];
  }
  let t35;
  if ($[51] !== imageAlt || $[52] !== imageSrc) {
    t35 = <Image src={imageSrc} alt={imageAlt} width={620} height={480} className="h-auto w-full object-contain" />;
    $[51] = imageAlt;
    $[52] = imageSrc;
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  let t36;
  if ($[54] !== t33 || $[55] !== t34 || $[56] !== t35) {
    t36 = <motion.div animate={t33} transition={t34}>{t35}</motion.div>;
    $[54] = t33;
    $[55] = t34;
    $[56] = t35;
    $[57] = t36;
  } else {
    t36 = $[57];
  }
  let t37;
  if ($[58] !== t28 || $[59] !== t29 || $[60] !== t30 || $[61] !== t36) {
    t37 = <div className="flex justify-center lg:col-span-6 lg:justify-center"><motion.div initial={t28} whileInView={t29} animate={t30} viewport={t31} transition={t32} className="relative w-full max-w-[620px] scale-105 sm:scale-110 lg:scale-115">{t36}</motion.div></div>;
    $[58] = t28;
    $[59] = t29;
    $[60] = t30;
    $[61] = t36;
    $[62] = t37;
  } else {
    t37 = $[62];
  }
  let t38;
  if ($[63] !== t27 || $[64] !== t37) {
    t38 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8"><div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-10">{t27}{t37}</div></div>;
    $[63] = t27;
    $[64] = t37;
    $[65] = t38;
  } else {
    t38 = $[65];
  }
  let t39;
  if ($[66] !== t38 || $[67] !== t6) {
    t39 = <section className={t6}>{t7}{t38}</section>;
    $[66] = t38;
    $[67] = t6;
    $[68] = t39;
  } else {
    t39 = $[68];
  }
  return t39;
}